import { Editor } from "@/core/editor"
import { BitmapIOAdapter } from "@/io/formats/bitmap/bitmap-adapter"
import { RawIOAdapter } from "@/io/formats/raw/raw-adapter"
import { RawLoaderConnection } from "@/lib/raw/raw-loader-connection"
import { MainAIMaskResolver } from "@/io/assets/ai-mask/main-ai-mask-resolver"
import { MainLUTResolver } from "@/io/assets/lut/lut-resolver"
import { HealingAiResolver } from "@/io/assets/healing/healing-ai-resolver"
import { createApplicationWebGLContext } from "./canvas"
import { ExtendedWebGLContextAttributes } from "@/core/backends/webgl/canvas"

let editor: Editor

const getGLContext = (): WebGL2RenderingContext | null => {
	const baseAttrs: Partial<ExtendedWebGLContextAttributes> = {
		depth: false,
		stencil: false,
	}

	// Try preferred → essential → bare minimum. Each step relaxes a constraint:
	// 1. high-performance powerPreference + failIfMajorPerformanceCaveat
	// 2. default powerPreference + failIfMajorPerformanceCaveat
	// 3. default powerPreference, no failIfMajorPerformanceCaveat
	try {
		return createApplicationWebGLContext({
			...baseAttrs,
			failIfMajorPerformanceCaveat: true,
			powerPreference: "high-performance",
		})
	} catch {
		/* fall through */
	}

	try {
		return createApplicationWebGLContext({
			...baseAttrs,
			failIfMajorPerformanceCaveat: true,
			powerPreference: "default",
		})
	} catch {
		/* fall through */
	}

	try {
		return createApplicationWebGLContext({ ...baseAttrs, powerPreference: "default" })
	} catch {
		return null
	}
}

export const getEditor = () => {
	if (!editor) {
		editor = new Editor({
			label: "main",
			resolvers: [MainAIMaskResolver, MainLUTResolver, new HealingAiResolver()],
			io: [
				new BitmapIOAdapter(),
				new RawIOAdapter({
					rawConnection: RawLoaderConnection,
				}),
			],
			gl: getGLContext(),
		})

		if (import.meta.env.DEV) {
			// @ts-expect-error Window has no property `editor`
			window.editor = editor
		}
	}

	return editor
}

export const useEditor = getEditor
